import { createNotificationPreferencesService } from '@shared/api'
import { authorizedHttpClient } from './http-client'

export const NotificationPreferencesService = createNotificationPreferencesService(
  authorizedHttpClient,
  import.meta.env.VITE_API_URL,
)
